import(/* webpackMode: "eager", webpackExports: ["FloatingAppDownload"] */ "/opt/build/repo/app/_components/FloatingAppDownload.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/components/pages/homepage/V2/DownloadButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MarqueeClient"] */ "/opt/build/repo/components/pages/homepage/V2/MarqueeClient.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/components/parts/NextLink/Link.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
